
import AjaxService from '../Ajax/index.jsx';


var CategoryList = function() { };
CategoryList.prototype.actionName = 'cs:category-list';
CategoryList.prototype.fetchPage = function(page) {
  return AjaxService.fetch(this.actionName)
    .then(function(response) {
      if (response) {
        return response;
      } else {
        return [];
      }
    });
};


export default CategoryList;

